import { cn } from 'utils/cn.tsx';

interface Props {
	animate?: boolean;
	isRow?: boolean;
	dataTest?: string;
}

export function OfferSkeleton({ animate = true, isRow = false, dataTest }: Props) {
	if (isRow) {
		return (
			<div
				data-test={dataTest || 'offer-skeleton'}
				class={cn('offer-card @container w-full h-20 relative overflow-hidden skeleton', {
					'animate-pulse': animate,
				})}
			>
				<div class="flex items-center w-full h-full">
					<div class="size-20 flex-shrink-0 bg-light-gray rounded-lg"></div>
					<div class="flex flex-col w-full gap-2">
						<div class="w-4/5 mdp:w-2/5 h-4 mdp:h-5 ml-3 bg-light-gray rounded-lg"></div>
						<div class="w-3/5 mdp:w-1/5 h-4 mdp:h-5 ml-3 bg-light-gray rounded-lg"></div>
						<div class="mdp:hidden w-3/5 mdp:w-1/5 h-4 mdp:h-5 ml-3 bg-light-gray rounded-lg"></div>
					</div>
					<div class="hidden mdp:block w-2/12 h-5 ml-3 bg-light-gray rounded-lg"></div>
					<div class="hidden mdp:block w-8 h-5 ml-3 mr-8 bg-light-gray rounded-lg"></div>
				</div>
			</div>
		);
	}

	return (
		<div
			data-test={dataTest || 'offer-skeleton'}
			class={cn('offer-card @container w-full h-full relative overflow-hidden', {
				'animate-pulse': animate,
			})}
		>
			<div class="relative offer-card__image-wrapper rounded-2xl bg-light-gray"></div>
			<div class="h-[68px] pt-3">
				<div class="w-4/5 h-5 mb-4 bg-light-gray rounded-lg"></div>
				<div class="w-3/5 h-5 bg-light-gray rounded-lg"></div>
			</div>
		</div>
	);
}
